module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article-w960.341d07e7.jpg";